import { render, staticRenderFns } from "./CreateSGShardedClusters.vue?vue&type=template&id=5b9ad1d9&scoped=true"
import script from "./CreateSGShardedClusters.vue?vue&type=script&lang=js"
export * from "./CreateSGShardedClusters.vue?vue&type=script&lang=js"
import style0 from "./CreateSGShardedClusters.vue?vue&type=style&index=0&id=5b9ad1d9&prod&scoped=true&lang=css"
import style1 from "./CreateSGShardedClusters.vue?vue&type=style&index=1&id=5b9ad1d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ad1d9",
  null
  
)

export default component.exports